const FolderExportOutlined = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <path
      fill='#25314C'
      d='M10.5 3.646H7.765L6.143 2.025a.44.44 0 0 0-.309-.129H3.501c-1.41 0-2.188.777-2.188 2.188v5.833c0 1.41.777 2.188 2.188 2.188h7c1.41 0 2.188-.777 2.188-2.188V5.834c-.001-1.41-.778-2.188-2.189-2.188m1.313 6.271c0 .92-.393 1.313-1.313 1.313h-7c-.92 0-1.312-.393-1.312-1.313V4.084c0-.92.392-1.313 1.312-1.313h2.152l1.622 1.622a.44.44 0 0 0 .31.128H10.5c.92 0 1.312.393 1.312 1.313zM7.404 8a.44.44 0 0 1-.094.476L6.143 9.643a.436.436 0 1 1-.618-.619l.42-.42H4.084a.438.438 0 0 1 0-.875h1.86l-.42-.42a.438.438 0 1 1 .619-.619L7.31 7.857q.06.063.094.143'
    />
  </svg>
);

export default FolderExportOutlined;
